import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton, ListItemIcon, ListItemText } from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { secondAxios } from "../../../../../../../../api/axios";
import { useMcsContext } from "../../../MCS.context";
import { useMrqContext } from "../MrqContext";
import { useBOMDashboardContext } from "../../BOMDashboard.context";

export default function ActionsMenu({ sx, type, id }) {
  const { plant, setPlant, mrqList, setMrqList } = useMcsContext();
  const { setMrqSelection, onEditMrq: onEdit } = useMrqContext();
  const { setSelectedDrawings } = useBOMDashboardContext();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDelete = async () => {
    const res = await secondAxios.delete(`/${type}/${id}`);

    if (res?.status === 200) {
      setSelectedDrawings([]);
      setPlant({
        ...plant,
        [type + "s"]: plant[type + "s"].filter((m) => m.id !== id),
        selectedMrq: { id: "" },
        selectedBidMrq: {},
        selectedDrawings: [],
      });
      setMrqList(mrqList.filter((m) => m.id !== id));
      setMrqSelection({
        selectedMrq: "",
        revisions: [],
        selectedRevision: "",
      });
      setAnchorEl(null);
    }
  };

  const onClickEdit = () => {
    onEdit();
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        id="basic-IconButton"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ ...sx }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem onClick={onClickEdit}>
          <ListItemIcon>
            <ModeEditIcon color="success" fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit MRQ</ListItemText>
        </MenuItem>
        <MenuItem onClick={onDelete}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete MRQ</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
